module.exports = __webpack_public_path__ + "img/general-video.efb09778.png";